// extracted by mini-css-extract-plugin
export default {"pageWrapper":"PageWrapper_pageWrapper__oPLoJ","main":"PageWrapper_main__XPRFR"};